import {
  queryProducts,
  deleteProduct,
  updateProductStatus,
  batchUpdateSkuPrice,
  updateProductStatusBatch
} from "@/graphql/product.gql";
import { productConditionFilter } from "@root/lib/common.ts";
import { QueryBrandsFormat } from "@/graphql/Brands.gql";
import { easyMutate, resRest } from "@root/lib/utils";
import { httpServer as pcrHttp } from "@root/lib/axios/pcrAxios";
import { httpServer as http } from "@/lib/axios";

export default {
  namespaced: true,
  state: {
    productData: {
      datalist: [],
      pageInfo: {
        totalCount: 0
      }
    },
    PageInput: {
      pageNum: 1,
      pageSize: 10
    },
    params: {
      productName: ""
    },
    loading: true,
    typeList: {
      productName: 4,
      productCode: 4,
      productNo: 4,
      brandCode: -1,
      categoryCode: -1,
      onboardTime: 2,
      createTime: 2,
      status: 0,
      barcode: 4
    },
    exportParams: {}
  },
  getters: {
    productList(state: any) {
      return state.productData.datalist || [];
    },
    total(state: any) {
      return state.productData.pageInfo.totalCount || 0;
    }
  },
  actions: {
    async queryProductAttributes({ rootState }, params = {}) {
      const { data } = await pcrHttp("/productAttr/query", 
        params
      );
      return data ? data || [] : [];
    },
    async getPorducts({ commit, state, rootState }: any, data?: any) {
      state.loading = true;
      let conditionList = [];
      for (let i in state.params) {
        if (
          (state.params[i] && JSON.stringify(state.params[i]) !== "[]") ||
          state.params[i] === 0
        ) {
          conditionList = [
            ...conditionList,
            ...productConditionFilter(i, state.params[i], state.typeList[i])
          ];
        }
      }
      let base = {
        locale: localStorage.getItem("localeLanguage"),
        channel: localStorage.getItem("channel"),
        // orgCode: "default",
        orgCode: localStorage.getItem("org") || "default",
        sortList: [
          {
            key: "createTime",
            type: 1
          }
        ]
      };
      let params = {
        ...base,
        conditionList: conditionList
      };
      const res = await rootState.gql.query({
        query: queryProducts,
        variables: {
          PageInput: state.PageInput,
          condition: params
        }
      });
      state.loading = false;
      let list = resRest(res.data, {
        path: "queryProductList.datalist",
        node: "data"
      });
      commit("setProductData", {
        ...res.data.queryProductList,
        datalist: list
      });
      commit("setExportParams", {
        ...base,
        conditionList: conditionList
      });

      return { list: list, searchParams: params };
    },
    async deleteProduct({ rootState }: any, data: any) {
      await rootState.gql.mutate({
        mutation: deleteProduct,
        variables: { input: data }
      });
    },
    async UpdateProductStatus({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: updateProductStatus,
        variables: { input: data }
      });
    },
    async getBrands({ commit, state, rootState }: any, data?: any) {
      const res = await rootState.gql.query({
        query: QueryBrandsFormat,
        variables: data
      });
      let result = {
        list: resRest(res.data) || [],
        total: res.data.api.pageInfo.totalCount
      };
      return result;
    },
    async batchUpdateSkuPrice({ commit, state, rootState }: any, data?: any) {
      await rootState.gql.mutate({
        mutation: batchUpdateSkuPrice,
        variables: { input: data }
      });
    },
    async updateProductStatusBatch(
      { commit, state, rootState }: any,
      data: any
    ) {
      await rootState.gql.mutate({
        mutation: updateProductStatusBatch,
        variables: { input: data }
      });
    },
    // 商品管理 - 分页查询PCR商品列表
    async queryPCRProductList({ rootState }, params = {}) {
      const { data } = await http("/pcr/product/queryList", params);
      return data
        ? data.data || { list: [], total: 0 }
        : { list: [], total: 0 };
    },
  },
  mutations: {
    setProductData(state: any, data: any) {
      state.productData = data;
    },
    setPageInput(state: any, data: any) {
      state.PageInput = data;
    },
    setParams(state: any, data: any) {
      state.params = data;
    },
    setExportParams(state: any, data: any) {
      state.exportParams = data;
      console.log(data, 76);
    }
  }
};
